import * as React from 'react';

import cn from 'classnames';

import { getIsListingPage, getIsViewPage } from './utils';

export const VIEW_VIEW = 'view_view';
export const LISTING_SEARCH = 'listing_search view_search';

const GuiDefHiddenInput = ({
  className = '',
  ...rest
}: {
  className?: string;
  defaultValue?: any;
  [x: string]: any;
}) => {
  const classNames = cn(className, {
    [VIEW_VIEW]: getIsViewPage(),
    [LISTING_SEARCH]: getIsListingPage(),
  });
  return <input {...rest} type="hidden" autoComplete="off" readOnly className={classNames} />;
};

export default GuiDefHiddenInput;
